import React from "react";
import data from "../../../data/data";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import "./agentsdetails.scss";

const InfoAgent = (props) => {
  const [AgentList, setAgentList] = React.useState(data);

  const found = AgentList.find(
    (element) =>
      element.name.toUpperCase() === props.match.params.name.toUpperCase()
  );

  if (found === undefined) {
    return <div>404</div>;
  }

  const CheckCost = (i) => {
    if (i === "Signature") {
      return <div></div>;
    } else if (i === "Basic") {
      return (
        <svg viewBox='0 0 48 48' class='w-5 cred' data-v-1d49dc39=''>
          <title data-v-1d49dc39=''>Creds</title>{" "}
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M7.99829 13.5485V7.99927H13.3318V11.3393L14.9884 12.9958C17.4418 10.9843 20.5799 9.77715 24 9.77715C27.4198 9.77715 30.5577 10.9841 33.011 12.9953L34.6669 11.3393V7.99927H40.0005V13.5485L36.4432 17.1058C37.5771 19.148 38.2228 21.4985 38.2228 24C38.2228 26.5013 37.5771 28.8519 36.4432 30.894L40.0005 34.4513V40.0005H34.6669V36.6605L33.011 35.0046C30.5578 37.0158 27.4198 38.2228 24 38.2228C20.5799 38.2228 17.4417 37.0156 14.9883 35.004L13.3318 36.6605V40.0005H7.99829V34.4513L11.5563 30.8932C10.4228 28.8513 9.77722 26.501 9.77722 24C9.77722 21.4989 10.4228 19.1486 11.5564 17.1066L7.99829 13.5485ZM24 32.8892C28.9094 32.8892 32.8893 28.9094 32.8893 24C32.8893 19.0906 28.9094 15.1107 24 15.1107C19.0906 15.1107 15.1108 19.0906 15.1108 24C15.1108 28.9094 19.0906 32.8892 24 32.8892Z'
            data-v-1d49dc39=''
          ></path>
        </svg>
      );
    }
    return <div>&nbsp;Orbs</div>;
  };

  return (
    <div className=''>
      <Helmet>
        <title>Valorant Tracker | {found.name}</title>
        <meta name='description' content='Helmet application' />
      </Helmet>
      <div class='AgentBg hidden lg:block '>
        <img src={found.characterimg} alt='Agent Jett Background' />
      </div>

      <div className='character-details relative p-32 px-5'>
        <div class='box1'>
          <Link to='/agents'>
            <div className=' flex justify-center items-center p-5 uppercase btn btn-one'>
              {" "}
              <i class='mr-5 fas fa-arrow-left'></i>
              <span>Agent list</span>
            </div>
          </Link>
        </div>
        <div className='flex flex-col  min-w-full  lg:justify-center lg:flex-row-reverse '>
          <img
            src={found.img}
            className='lg:w-2/6 lg:h-full flex-shrink'
            alt=''
          />

          <div className='overview bg-gray-700 w-full lg:w-1/2 p-6 '>
            <div className='w-1/2 mx-auto text-center uppercase tracking-widest text-2xl lg:text-6xl text-white font-black'>
              {found.name}
            </div>
            <div className='flex justify-evenly flex-col lg:flex-row  type origin mt-10'>
              <div className='flex items-center flex-col'>
                <div className='title-head '>TYPE</div>
                <div className='flex   type-s text-5xl text-white'>
                  <img className='h-10 mt-3 ' src={found.type_img} alt='' />
                  <div className='ml-4'>{found.type}</div>
                </div>
              </div>
              <div className='flex flex-col items-center'>
                <div className='title-head'>ORIGIN</div>
                <div className='flex flex-col items-center font-mono uppercase text-3xl text-white'>
                  <div>{found.origin}</div>
                  <img className=' w-12' src={found.origin_img} alt='' />
                </div>
              </div>
            </div>
            <div className='desc'>{found.desc}</div>
            <hr></hr>
            <div>
              <div className='title-head uppercase text-center pt-5'>
                Abilities
              </div>

              {found.abilities.map((element) => (
                <div>
                  <div className='flex flex-col  lg:flex-row text-white bg-gray-800 m-1 lg:m-5 px-5 py-5'>
                    <div className='flex-shrink-0 w-32'>
                      {" "}
                      <img className=' ' src={element.icon_img} alt='' />
                    </div>

                    <div className='ml-6'>
                      <div className='font-extrabold abbility-name text-2xl'>
                        {element.name}
                      </div>
                      <div className='font-bold text-lg'>
                        Type : {element.type}
                      </div>
                      <div className='flex  font-bold text-lg'>
                        Cost : {element.cost} {CheckCost(element.type)}
                      </div>
                      <div className=''>{element.desc}</div>
                    </div>
                    <div></div>
                  </div>
                  <hr></hr>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoAgent;
